import { render, staticRenderFns } from "./InicisSuccessComponent.vue?vue&type=template&id=50124ee8&"
import script from "./InicisSuccessComponent.vue?vue&type=script&lang=js&"
export * from "./InicisSuccessComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports